import { DataSourceExecutionEvent, DataSourceMode } from "@mcleod/components";

import { AutogenLayoutEdiPartnerValues } from "./autogen/AutogenLayoutEdiPartnerValues";

export class EdiPartnerValues extends AutogenLayoutEdiPartnerValues {
    private _allocationEnabled: boolean;

    override onLoad(): void {

    }

    sourceViewEdiOrderAfterModeChange(){
        if (this.mainDataSource.mode == DataSourceMode.SEARCH) {
           this.textboxEdiSegAllocCode.visible = this.getAllocationEnabled;
        }
    }

    sourceSegAllocControlAfterExecution(event: DataSourceExecutionEvent){
        this._allocationEnabled = event.data?.get("is_active") === "Y" ? true : false as boolean;
        if(!this.getAllocationEnabled){
            this.textboxEdiSegAllocCode.visible = this._allocationEnabled;
        }
    }

    get getAllocationEnabled(){
        return this._allocationEnabled;
    }

}
